import React from 'react';
import '../../../App.css';


const CircleNum = ({
    children,
    customSize = '16px'
}) => {
    return (
        <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{
                padding: '6px',
                width: customSize,
                height: customSize,
                borderRadius: '50%',
                marginRight: '6px',
                backgroundColor: 'var(--common-back-deep2-color)',
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            }}>
                <p style={{lineHeight: '1', fontWeight: '700' }}>
                    {children}
                </p>
            </div>
        </div>
);
};

export default CircleNum;